export default __webpack_public_path__ + "static/media/Bloom.1050a6209ae1a6ff16762ed93874b378.webp";